import {
  type AgentRunBindingOption,
  AgentRunBindingOptionSchema,
  type AgentRunPage,
  AgentRunPageSchema,
  type ListAgentRunsQuery,
} from '@sbc/domain-models/gateway';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiGet } from './client';

const AGENT_RUNS_KEY = ['admin', 'agent-runs'];

const AgentRunBindingOptionListSchema = z.array(AgentRunBindingOptionSchema);

function toSearch(query: ListAgentRunsQuery): string {
  const params = new URLSearchParams();
  params.set('page', String(query.page));
  params.set('pageSize', String(query.pageSize));
  if (query.channelBindingId) {
    params.set('channelBindingId', query.channelBindingId);
  }
  if (query.status) {
    params.set('status', query.status);
  }
  if (query.inFlight !== undefined) {
    params.set('inFlight', String(query.inFlight));
  }
  return params.toString();
}

export function useAgentRuns(query: ListAgentRunsQuery) {
  return useQuery<AgentRunPage>({
    queryKey: [...AGENT_RUNS_KEY, 'list', query],
    queryFn: () => apiGet(`/api/admin/agent-runs?${toSearch(query)}`, AgentRunPageSchema),
    // Queued and running rows move without anyone touching the screen.
    refetchInterval: 30_000,
  });
}

export function useAgentRunBindings() {
  return useQuery<AgentRunBindingOption[]>({
    queryKey: [...AGENT_RUNS_KEY, 'bindings'],
    queryFn: () => apiGet('/api/admin/agent-runs/bindings', AgentRunBindingOptionListSchema),
  });
}
